/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
export type EnqueteIndexPagePaginationFragment = { limit: number, offset: number, totalCount: number };

export const EnqueteIndexPagePaginationFragmentDoc = gql`
    fragment EnqueteIndexPagePagination on OffsetBasedPageInfo {
  limit
  offset
  totalCount
}
    `;